function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { PartnersViewMessageType } from './partnersViewInboundMessages';
import { Constants } from '../utils/constants';
import { SpzaInstrumentService } from '../services/telemetry/spza/spzaInstrument';
import { logger } from '@src/logger';
/*
  Send messages to partners view(iframe).
 */ export class OutboundMessagesHandler {
    constructor(iframeElementId, targetOrigin){
        _define_property(this, "iframeElementId", void 0);
        _define_property(this, "targetOrigin", void 0);
        _define_property(this, "postSetDataMessage", (context)=>{
            const message = {
                messageType: PartnersViewMessageType.SetContext,
                context: context
            };
            this.postMessage(message);
        });
        _define_property(this, "postScrollChangeMessage", (xOffset, yOffset)=>{
            const message = {
                messageType: PartnersViewMessageType.ScrollChange,
                xOffset: xOffset,
                yOffset: yOffset
            };
            this.postMessage(message);
        });
        _define_property(this, "postSizeChangeMessage", ({ width, height, frameLeft, frameTop })=>{
            const message = {
                messageType: PartnersViewMessageType.SizeChange,
                width,
                height,
                frameLeft,
                frameTop
            };
            this.postMessage(message);
        });
        _define_property(this, "postMessage", (message)=>{
            const partnersObj = document.getElementById(this.iframeElementId);
            if (partnersObj) {
                const iframeElement = partnersObj;
                if (iframeElement) {
                    iframeElement.contentWindow.postMessage(JSON.stringify(message), this.targetOrigin);
                } else {
                    this.logErrorTelemetry("OutboundMessagesHandler Error - can't send message because iframe element not found");
                }
            }
        });
        _define_property(this, "logErrorTelemetry", (details)=>{
            const payload = {
                page: window && window.location ? window.location.href : '',
                action: Constants.Telemetry.Action.PartnerMessageSender,
                actionModifier: Constants.Telemetry.ActionModifier.Error,
                details: details
            };
            SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
            logger.error(payload.details, {
                action: payload.action,
                actionModifier: payload.actionModifier
            });
        });
        this.iframeElementId = iframeElementId;
        this.targetOrigin = targetOrigin;
    }
}
